module.exports = __webpack_public_path__ + "img/glass-blur-top_mobile.060c9db4.png";